import { computed, ref } from 'vue';
import {
  isEmpty, prop, propOr, sortBy,
} from 'ramda';
import useCallEndPointWith from '@/services/backend/useCallEndPointWith';
import { useGlobalState } from '@/store/user.store';

export function fetchPlans(useCache = false) {
  const { currentPlans } = useGlobalState();

  if (useCache && currentPlans.hasData()) {
    return {
      fetch: async () => {
      },
      response: ref(currentPlans.data()),
      isLoading: false,
    };
  }

  const { callEndpoint, endpointData, isLoading } = useCallEndPointWith('plans');

  const fetch = async () => {
    await callEndpoint({
      method: 'GET',
    })
      .then((response) => {
        if (!isEmpty(response)) {
          const expire = propOr(Date.now() + 1, 'expireCacheTimestamp', response);
          currentPlans.set(prop('plans', response), expire);
        }
        return response;
      });
  };

  const response = computed(() => {
    const ret = propOr([], 'plans', endpointData.value);
    if (!isEmpty(ret)) {
      return sortBy(prop('planId'))(ret);
    }
    return ret;
  });

  return { fetch, response, isLoading };
}

export function findPlanById(id) {
  const { fetch, response } = fetchPlans();

  return fetch().then(() => response.value.find((p) => p.planId === id));
}
